<script>
import { mapGetters } from 'vuex'
import mixin from '@/plans/mx/shopping-cart';
import { isZoomMeetingAsAddonCard, ZOOM_METTING_EDU_I18N_TITLE_KEY } from '@/plans/ZOOM_MEETING/common/utils';
import { CART_DISPLAY_MODE } from '../mx/shopping-cart.vue';
import { getAgreementAcceptedDesc } from './config/healthcare/helpers'

export const categories = {
  basic: 'billing.planform.title.zoom_one',
  pro: 'billing.planform.title.zoom_one_pro',
  biz: 'billing.planform.title.zoom_one_biz',
  education: ZOOM_METTING_EDU_I18N_TITLE_KEY,
};

export default {
  mixins: [mixin],
  computed: {
    ...mapGetters(['healthcareInfo', 'addressInfo']),
    mode(){
      if(this.$context.is.delta) return CART_DISPLAY_MODE.DELTA;
      return CART_DISPLAY_MODE.SUM;
    },
    shouldRenderHealthcareCart({ healthcareInfo, addressInfo }) {
      return (
        healthcareInfo.agreementAccepted &&
        // On the checkout page, users can opt out of healthcare by selecting a country that doesn't meet the conditions.
        !(this.$context.is.checkoutPage && addressInfo.country && healthcareInfo.countryCode !== addressInfo.country)
      )
    },
  },
  methods: {
    renderTitle(plan) {
      if ((this.$context.is.pro2biz || this.migratePlanState.is.pro2biz) && !this.$context.is.edu) {
        return (
          <div>
            {this.mx_title(this.$t(categories['basic']))}
            {this.mx_subTitle(this.$t('billing.pro2biz.title'), this.mx_price$(plan))}
          </div>
        );
      }
      return <div>{this.mx_title(this.$t(categories[plan.category]), this.mx_price$(plan))}</div>;
    },
    renderHealthcareCart() {
      return (
        <div class="opc-healthcare-cart">
          {this.mx_subTitle(this.$t('billing.healthcare.title'))}
          <div class="opc-cart-item__text">
            {getAgreementAcceptedDesc(this.healthcareInfo.businessCountry, this.$t.bind(this))}
          </div>
        </div>
      )
    },
    $renderSuccessTitle() {
      return this.mx_plans.map(plan => {
        return (<div class='opc-cart-item'>
          {this.renderTitle(plan)}
        </div>);
      });
    },
    $renderPrice(plans) {
      return (plans || this.mx_plans).map((plan) => {
        {
          /* FREE TRIAL - Specific UI for free trial */
        }
        if (!!plan.isOnlineFreeTrial && !!plan.trialDays) {
          return (
            <div class="opc-cart-item">
              {this.mx_freeTrialTitle(this.$t(categories[plan.category]))}
              {this.mx_license(plan.cartInfo.selected_number)}
              {this.mx_freeTrialDesc(plan.trialDays)}
              {this.mx_discount(plan.plan_code)}
              {this.mx_cycle(plan.billing_cycle)}
              {this.mx_edit(plan)}
            </div>
          );
        }
        return (
          <div class="opc-cart-item">
            {this.renderTitle(plan)}
            {this.mx_discount(plan.plan_code)}
            {this.mx_license$(plan)}
            {this.mx_cycle(plan.billing_cycle)}
            {this.mx_edit(plan)}
            {!this.mx_isLastBasePlanForTheSameBillingCycle &&
              (!this.mx_isLastBasePlan || isZoomMeetingAsAddonCard()) &&
              this.mx_remove(plan)}
            {this.shouldRenderHealthcareCart && this.renderHealthcareCart()}
          </div>
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-healthcare-cart {
  margin-top: 8px;
}
</style>
